export const getDownloadPricesList = async (apiInstance, clientPriceListId) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Export/DownloadExcel?clientPriceListId=${clientPriceListId}`,
    requestParameters
  )
}
